<template>
    <div class="calendar rccl-common-calendar">
        <i class="calendar_close"></i>
        <div class="calendar__title">
            <div class="title title__text">
                <div class="title__year">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                        <span class="year__text">{{initDate.getFullYear()}}年</span>
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu year-dropdown" role="menu" v-if="allowPreYear">
                        <li v-for="i in maxAge" :key="('allowPreYear_'+i)">
                            <a @click="onYearChange(now.getFullYear() - i + 1)">{{now.getFullYear() - i + 1}}年</a>
                        </li>
                    </ul>
                    <ul class="dropdown-menu year-dropdown" role="menu" v-else>
                        <li v-for="i in maxYear" :key="('maxPassPortExpiresIn_'+i)">
                            <a @click="onYearChange(now.getFullYear() + i - 1)">{{now.getFullYear() + i - 1}}年</a>
                        </li>
                    </ul>
                </div>
                <div class="title__month">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                        <span class="month__text">{{initDate.getMonth() + 1}}月</span>
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu month-dropdown" role="menu" v-if="allowPreYear">
                        <li v-for="i in preYearMonthCount" :key="('preYearMonth_'+i)">
                            <a @click="onMonthChange(i)">{{i}}月</a>
                        </li>
                    </ul>
                    <ul class="dropdown-menu month-dropdown" role="menu" v-else>
                        <li v-for="i in 12" :key="('afterYearMonth_'+i)">
                            <a v-if="i>=afterYearMonthStart" @click="onMonthChange(i)">{{i}}月</a>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <div class="calendar--header">
            <div class="calendar--header__weekday calendar--cell">周日</div>
            <div class="calendar--header__weekday calendar--cell">周一</div>
            <div class="calendar--header__weekday calendar--cell">周二</div>
            <div class="calendar--header__weekday calendar--cell">周三</div>
            <div class="calendar--header__weekday calendar--cell">周四</div>
            <div class="calendar--header__weekday calendar--cell">周五</div>
            <div class="calendar--header__weekday calendar--cell">周六</div>
        </div>
        <div class="calendar--body">
            <div class="calendar--body__line" v-for="(week, i) in weeks" :key="('week_'+i)">
                <div class="line day calendar--cell" v-for="(day, j) in week" :key="('day_'+i+'_'+j)">
                    <span v-show="day.name>0" @click="onDateClick(day.code)">{{day.name}}</span>
                </div>
            </div>
        </div>
        <div class="calendar_close" @click="onDateClick()"><img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/closed.png"></div>
    </div>
</template>

<script>
export default {
    name: "RcclCalendar",
    props: {
        // 默认显示的日期
        defaultDate: {
            type: String,
            default () {
                return '1980-01-01'
            }
        },
        // 日期往前算还是往后算
        allowPreYear: {
            type: Boolean
        },
        maxYear:{
            type: Number,
            default: 21
        }
    },
    data() {
        return {
            initDate: null,
            maxAge: 100,
            maxPassPortExpiresIn: 21,
            now: new Date()
        }
    },
    beforeMount() {
        this.initCalendar(this.defaultDate)
    },
    mounted() {

    },
    methods: {
        initCalendar (newValue) {
            if (newValue && newValue.length > 0) {
                let initDate = new Date(newValue)
                if (initDate && initDate instanceof Date)  {
                    this.initDate = new Date(`${initDate.getFullYear()}-${initDate.getMonth()+1}-01`)
                }
            } else if (this.allowPreYear) {
                this.initDate = new Date('1980-01-01')
            } else {
                this.initDate = new Date(`${this.now.getFullYear()}-${this.now.getMonth()+1}-01`)
            }
        },
        onYearChange (year) {
            let thisYear = this.initDate.getFullYear(),
                thisMonth = this.initDate.getMonth() + 1;
            if (year != thisYear) {
                this.initDate = new Date(year + "-" + thisMonth + "-01")
            }
        },
        onMonthChange (month) {
            let thisYear = this.initDate.getFullYear(),
                thisMonth = this.initDate.getMonth() + 1
            if (month != thisMonth) {
                this.initDate = new Date(thisYear + "-" + month + "-01")
            }
        },
        onDateClick (date) {
            this.$emit('onDateClicked', date)
        },
        pad (num) {
            return num < 10 ? "0" + num : num;
        },
        formateDate(date) {
            return `${date.getFullYear()}-${this.pad(date.getMonth() + 1)}-${this.pad(date.getDate())}`
        }
    },
    computed: {
        preYearMonthCount () {
            return this.now.getFullYear() == this.initDate.getFullYear() ? this.now.getMonth() + 1 : 12
        },
        afterYearMonthStart () {
            if  (this.now.getFullYear() == this.initDate.getFullYear()) {
                let startDate = new Date(this.defaultDate)
                if (startDate && startDate instanceof Date) {
                    if (startDate.getFullYear() == this.now.getFullYear()) {
                        return startDate.getMonth() + 1;
                    } else {
                        return this.now.getMonth() + 1;
                    }
                }
                return this.now.getMonth() + 1;
            } else {
                return 1;
            }
        },
        weeks () {
            // 根据select month，组装日历数据
            // 日历数组按照周来排列数组，每周又是一个数组，放一周7天的日期
            if (!this.initDate) return []
            let calendar = []
            let beginDate = new Date(this.initDate.getTime())
            let nextMonth = new Date(this.initDate.getTime())
            nextMonth = new Date(nextMonth.setMonth(nextMonth.getMonth() + 1))
            let index = 0
            while(beginDate.getTime() < nextMonth.getTime() && index <= 7) {
                let week = []
                for (let i = 0; i < 7; i++) {
                    let day = i
                    if (day == 0) day = 7
                    if ((index == 0 && beginDate.getDay() > (i)) || beginDate.getTime() >= nextMonth.getTime()) {
                      console.log(i + '++' + beginDate.getDay())
                        week.push({
                            code: '',
                            name: 0,
                            day: day
                        })
                    } else {
                        const date = this.formateDate(beginDate)
                        console.log(i, date)
                        week.push({
                            code: date,
                            name: beginDate.getDate(),
                            day: day
                        })
                        beginDate = new Date(beginDate.setDate(beginDate.getDate()+ 1))
                    }
                }
                calendar.push(week)
                index++
            }
            return calendar
        }
    },
    watch: {
        defaultDate (newValue) {
            this.initCalendar(newValue)
        }
    }
}
</script>

<style lang="less" scoped>
button:focus {
  outline: none; }
.calendar {
  width: 262px;
  margin-top: 20px;
  padding-top: 20px;
  padding-left: 4px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1); }
  .calendar_close {
    position: absolute;
    top: -5%;
    right: -5%;
    cursor: pointer;
    img {
        width: 25px;
    }
}
  .calendar .leftArrow {
    width: 0;
    height: 0;
    right: 5px;
    border-top: 5px solid white;
    border-right: 10px solid #cdcdcd;
    border-bottom: 5px solid white; }
  .calendar .rightArrow {
    width: 0;
    height: 0;
    left: 5px;
    border-top: 5px solid white;
    border-left: 10px solid #cdcdcd;
    border-bottom: 5px solid white; }
  .calendar .leftArrow.active {
    border-right-color: #fbc300; }
  .calendar .rightArrow.active {
    border-left-color: #fbc300; }
  .calendar .calendar__title {
    text-align: center; }
    .calendar .calendar__title .title {
      position: relative;
      display: inline-block;
      vertical-align: middle; }
      .calendar .calendar__title .title .title__year {
        display: inline-block;
        vertical-align: middle; }
      .calendar .calendar__title .title .title__month {
        margin-left: 5px;
        display: inline-block;
        vertical-align: middle; }
  .calendar .calendar--header .calendar--header__weekday {
    display: inline-block;
    vertical-align: middle;
    font-size: 12px;
    color: #4d4d4d; }
  .calendar .calendar--body {
    padding-bottom: 10px;
  }
  .calendar .calendar--body .calendar--body__line .line {
    display: inline-block;
    vertical-align: middle;
    position: relative; }
    .calendar .calendar--body .calendar--body__line .line div {
      position: relative;
      top: -3px;
      width: 36px;
      height: 24px;}
  .calendar .calendar--body .calendar--body__line .line:hover {
    cursor: pointer; }
  .calendar .calendar--body .calendar--body__line .vacation {
    color: #eeeeee; }
  .calendar .calendar--cell {
    width: 35px;
    height: 24px;
    text-align: center;
    margin-top: 10px;
    color: #999999; }
  .calendar {
    position: absolute;
    z-index: 1;
    border: 1px #AFC8E0 solid;}
  .calendar a{
    font-size: 14px !important;
    color: #333 !important;
  }
   .year-dropdown {
    max-height: 250px;
   }

   .month-dropdown {
     max-height: 250px;
   }

  #birthCalendar .year-dropdown {
    overflow-y: scroll;
  }

  .calendar .calendar__title .dropdown-menu li {
    cursor: pointer;
    width: 100%;
  }

  .btn .caret {
      margin-left: 3px;
  }

/*# sourceMappingURL=calendar-picker.css.map */

</style>
